import { lazy } from 'react'

import type { NavigationRoutesFn } from 'modules/core/lib/react-router'

const EmployeeTrainingList = lazy(() => import('modules/trainings/pages/employees/List'))
const SessionModalWrapper = lazy(
  () => import('modules/trainings/pages/employees/List/NextSessionModal')
)
const EmployeeNextSessionCertificates = lazy(
  () => import('modules/trainings/pages/employees/List/NextSessionModal/Certificates')
)
const EmployeeCertificatesUploadModal = lazy(
  () => import('modules/trainings/pages/employees/List/NextSessionModal/Certificates/Upload')
)
const RootPage = lazy(() => import('modules/trainings/pages/employees/RootPage'))
const EmployeeTrainingDetail = lazy(
  () => import('modules/trainings/pages/employees/TrainingDetail')
)
const TrainingDetail = lazy(() => import('modules/trainings/pages/employees/TrainingDetail/Detail'))
const EmployeesTrainingCertificates = lazy(
  () => import('modules/trainings/pages/employees/TrainingDetail/Detail/Certificates')
)
const EmployeesTrainingCertificateUpload = lazy(
  () => import('modules/trainings/pages/employees/TrainingDetail/Detail/Certificates/Upload')
)
const EmployeeFileViewer = lazy(
  () => import('modules/trainings/pages/employees/TrainingDetail/Detail/FileViewer')
)
const EmployeeSessionModal = lazy(
  () => import('modules/trainings/pages/employees/TrainingDetail/Detail/SessionModal')
)
const EmployeeSessionModalCertificates = lazy(
  () => import('modules/trainings/pages/employees/TrainingDetail/Detail/SessionModal/Certificates')
)
const EmployeeSessionModalUploadCertificateModal = lazy(
  () =>
    import('modules/trainings/pages/employees/TrainingDetail/Detail/SessionModal/Certificates/Upload')
)

const employeesRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.employees.id.training.path,
      element: <RootPage />,
      children: [
        {
          path: '',
          element: <EmployeeTrainingList />,
          children: [
            {
              path: navigation.employees.id.training.nextSession.path,
              element: <SessionModalWrapper />,
              children: [
                {
                  path: navigation.employees.id.training.nextSession.certificates.path,
                  element: <EmployeeNextSessionCertificates />,
                  children: [
                    {
                      path: navigation.employees.id.training.nextSession.certificates.upload.path,
                      element: <EmployeeCertificatesUploadModal />,
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          path: navigation.employees.id.training.detail.path,
          element: <EmployeeTrainingDetail />,
          children: [
            {
              path: navigation.employees.id.training.detail.view.path,
              element: <TrainingDetail />,
              children: [
                {
                  path: navigation.employees.id.training.detail.view.sessionDetail.path,
                  element: <EmployeeSessionModal />,
                  children: [
                    {
                      path: navigation.employees.id.training.detail.view.sessionDetail.certificates
                        .path,
                      element: <EmployeeSessionModalCertificates />,
                      children: [
                        {
                          path: navigation.employees.id.training.detail.view.sessionDetail
                            .certificates.upload.path,
                          element: <EmployeeSessionModalUploadCertificateModal />,
                        },
                      ],
                    },
                  ],
                },
                {
                  path: navigation.employees.id.training.detail.view.fileViewer.path,
                  element: <EmployeeFileViewer />,
                },
                {
                  path: navigation.employees.id.training.detail.view.certificates.path,
                  element: <EmployeesTrainingCertificates />,
                  children: [
                    {
                      path: navigation.employees.id.training.detail.view.certificates.upload.path,
                      element: <EmployeesTrainingCertificateUpload />,
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ]
}

export default employeesRoutes
